<template lang="pug">
.curso-main-container.introduccion
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
  
    .titulo-principal.color-acento-contenido
      .titulo-principal__numero.text-white
        span
          i.fas.fa-info
      h1 Introducción
    p.mb-5(data-aos='fade-right') Bienvenido al componente formativo 
      span.r-3 These are my hobbies
      |/<b>Estos son mis pasatiempos</b>. En el siguiente video, podrá encontrar, de forma general, la temática que estudiará.
    figure
      .video
        iframe(width="560" height="315" src="https://www.youtube.com/embed/rewIoo9CyVY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
    
</template>

<script>
export default {
  name: 'Introduccion',
  data: () => ({
    // variables de vue
  }),
}
</script>

<style lang="sass"></style>
